import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import ConfirmPageReducer from './confirmPageReducer';
import RejectPageReducer from './rejectPageReducer';
//IndexImportHygen
const allConfirmPageReducers = combineReducers({
    isResultReducer,
    ConfirmPageReducer,
    RejectPageReducer
    //IndexUsingHygen
})

export default allConfirmPageReducers;